import {
  Item,
  LargeCommercialPack,
  CalculateItemSalesPrice
} from '../../item/models/large_commercial_pack_env';
import { Env } from '../env';
import { ApiClient } from '../http/api_client';

export class CalculateItemSalesPriceWhenQuantityChangeRepository {
  /// 価格AdjustPF.数量変更時商品販売価格再計算を実行し、数量変更時商品販売価格再計算結果リストのEU販売価格（税込）、EU販売価格（税抜）を返却する
  /// @param companyId 企業ID
  /// @param departmentId 部門ID
  /// @param supplierId サプライヤID
  /// @param catalogItemCode カタログ商品コード
  /// @param regularDeliveryCatalogItemCode 定期配送商品コード
  /// @param quantity 数量
  /// @return 数量変更時商品販売価格再計算から取得したEU販売価格（税込）、EU販売価格（税抜）
  async getPriceCalculate(
    companyId: string,
    departmentId: string,
    supplierId: string,
    catalogItemCode: string,
    regularDeliveryCatalogItemCode: string,
    quantity: number
  ): Promise<LargeCommercialPack> {
    /// 数量変更時商品販売価格再計算のRequestを設定
    const priceCalculates = createPriceCalculateRequest(
      companyId,
      departmentId,
      supplierId,
      catalogItemCode,
      regularDeliveryCatalogItemCode,
      quantity
    );

    const result = await ApiClient.post(
      `${Env.SETTING.userPublicApi.urlBase}api/priceadjust/pricecalculate/calculateItemSalesPriceWhenQuantityChange`,
      priceCalculates
    );

    return new LargeCommercialPack(
      result[0].taxIncludeEuSalesPrice,
      result[0].taxExcludeEuSalesPrice
    );
  }
}

/// @param companyId 企業ID
/// @param departmentId 部門ID
/// @param supplierId サプライヤID
/// @param catalogItemCode カタログ商品コード
/// @param regularDeliveryCatalogItemCode 定期配送商品コード
/// @param quantity 数量
/// @return 数量変更時商品販売価格再計算のRequest
const createPriceCalculateRequest = (
  companyId: string,
  departmentId: string,
  supplierId: string,
  catalogItemCode: string,
  regularDeliveryCatalogItemCode: string,
  quantity: number
) => {
  const item = new Item(supplierId, catalogItemCode, regularDeliveryCatalogItemCode, quantity);
  return new CalculateItemSalesPrice(companyId, departmentId, [item]);
};
